import { Associate } from '@shared/types/business-unit/Associate';
import { Associate as EntityAssociate } from '@/types/entity/associate';

export const mapAssociate = ({
  accountId,
  firstName,
  lastName,
  email,
  customerEmail,
  roles,
  confirmed,
  isActive,
  lastLoginAt,
}: Associate): EntityAssociate => {
  return {
    id: accountId as string,
    firstName: firstName ?? '',
    lastName: lastName ?? '',
    email: email ?? '',
    // EWM-493 — clean display email; absent for B2C / unmigrated accounts.
    customerEmail,
    roles: (roles ?? []).filter((role) => !!role.key).map((role) => role.key as string),
    status: confirmed ? 'confirmed' : 'pending',
    // EWM-179 follow-up — defaults match the BE mapper (absent = active,
    // absent = never-logged-in renders '—').
    isActive: isActive ?? true,
    lastLogin: lastLoginAt ?? '',
  };
};
